import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from '../src/pages/LoginWeb/Login';
import Dashboard from './pages/Main/Dashboard';
import ProtectedRoute from './ProtectedRoute';
import PageTitleManager from './components/PageTitleManager';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <PageTitleManager />

        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Home />} />
          <Route path="/privacy" element={<Home />} />
          <Route path="/login" element={<Login />} />


          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
